import React, { useEffect, useState } from "react";
import Heading from "../../../component/Heading/Heading";
import TableComponent from "../../../component/Table/TableComponent";
import { TableCell, TableRow } from "@mui/material";
import { getHistory } from "../../../services/customer-services/customerBillingStatus";
import { changeDateFormate } from "../../../helper/changeDateFormate";
import { useTranslation } from "react-i18next";
import { formatAmount } from "../../../helper/formatAmount";

const columns = [
    { field: "orderNo", headerName: "Order No.", translationKey: 'payment_history_order_no' },
    { field: "subscriptionNumber", headerName: "Subscription Number", translationKey: 'payment_history_subscription_number' },
    { field: "subscriptionName", headerName: "Subscription Name", translationKey: 'payment_history_subscription_name' },
    { field: "invoiceDate", headerName: "Invoice Date", translationKey: 'payment_history_invoice_date' },
    { field: "amount", headerName: "Amount", translationKey: 'billing_amount' },
];

const History = () => {
    const { t } = useTranslation();
    const [pageNo, setPageNo] = useState(1);
    const [perPage, setPerPage] = useState(25);
    const [totalRecords, setTotalRecords] = useState(0);
    const [historyData, setHistoryData] = useState([])

    const getAllHistoryData = async (payload) => {
        const response = await getHistory(payload);
        setHistoryData(response?.history);
        setTotalRecords(response?.totalRecords ? response?.totalRecords : 0)
    }

    useEffect(() => {
        getAllHistoryData({ perPage, perPage })
    }, [pageNo, perPage])

    return (
        <div className="payment-history">
            <div className="payment-history-sub-Heading">
                <Heading text={t('payment_history_text')} className="payment-sub-heading" />
            </div>
            <TableComponent
                data={historyData}
                setPageNo={setPageNo}
                pageNo={pageNo}
                perPage={perPage}
                setPerPage={setPerPage}
                totalRecords={totalRecords}
                columns={columns}
            >
                {
                    historyData?.map((row, index) => {
                        return (
                            <TableRow key={index}>
                                <TableCell>{row.orderNumber}</TableCell>
                                <TableCell>{row.subscriptionNumber}</TableCell>
                                <TableCell>{row.planFrequency}</TableCell>
                                <TableCell>{changeDateFormate(row.confirmedAt)}</TableCell>
                                <TableCell>{`${formatAmount(row.planPrice)} EUR`}</TableCell>
                            </TableRow>
                        )
                    })
                }
            </TableComponent>
        </div>
    )
}

export default History;